import React, { Component } from 'react';
import i18n from 'i18n';
import BackButton from 'components/BackButton';
import scaleSize from 'utils/scale-size';
import { StyledBlock, StyledContent, StyledHeader, StyledStatusBar } from './StyledComponents';

const ONE_SCROLL_STEP = scaleSize(920);

const i18nScope = 'termsPage';

// TODO: вынести скролл бар и основную логику скролла в отдельный,
// переиспользуемый компонент
export default class TermsPage extends Component {
  contentBlockRef = React.createRef();

  state = {
    contentTopOffset: 0,
    statusBarTopPercentsOffset: 0,
  };

  onBack = () => {
    const { history } = this.props;
    history.goBack();
  };

  onKeydown = ({ keyCode }) => {
    const { downKeyCode, upKeyCode } = this.props;
    if (![downKeyCode, upKeyCode].includes(keyCode)) return;

    this.setOffsetPostions(keyCode === downKeyCode ? -ONE_SCROLL_STEP : ONE_SCROLL_STEP);
  };

  onWheel = ({ deltaY }) => this.setOffsetPostions(deltaY > 0 ? -ONE_SCROLL_STEP : ONE_SCROLL_STEP);

  setOffsetPostions = step => {
    const contentBlockHeight = this.contentBlockRef.current.offsetHeight;
    const { contentTopOffset: oldContentTopOffset } = this.state;
    let contentTopOffset = oldContentTopOffset + step;
    // проверка на overflow вверху или внизу
    if (Math.abs(contentTopOffset) + ONE_SCROLL_STEP > contentBlockHeight) {
      contentTopOffset = -contentBlockHeight + ONE_SCROLL_STEP;
    } else if (contentTopOffset > 0) {
      contentTopOffset = 0;
    }
    const statusBarTopPercentsOffset = (
      (Math.abs(contentTopOffset) + ONE_SCROLL_STEP) /
      contentBlockHeight
    ).toFixed(3);
    this.setState({
      contentTopOffset,
      statusBarTopPercentsOffset,
    });
  };

  componentDidMount() {
    const { terms, loadTerms } = this.props;
    document.addEventListener('keydown', this.onKeydown, true);
    document.addEventListener('wheel', this.onWheel, true);
    if (!terms) loadTerms();
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.onKeydown, true);
    document.removeEventListener('wheel', this.onWheel, true);
  }

  render() {
    const { contentTopOffset, statusBarTopPercentsOffset } = this.state;
    const { terms } = this.props;
    return (
      <>
        <BackButton onEnter={this.onBack} defaultSection />
        <StyledBlock>
          <StyledContent top={contentTopOffset} ref={this.contentBlockRef}>
            <StyledHeader>{i18n.t(`${i18nScope}.title`)}</StyledHeader>
            <div dangerouslySetInnerHTML={{ __html: terms }} />
          </StyledContent>
          <StyledStatusBar topPercentsOffset={statusBarTopPercentsOffset} />
        </StyledBlock>
      </>
    );
  }
}
